import React from 'react'
import { Section, Title, FaqList } from './styles'
import FaqItem from './faq-item'
import { FaqSection as FaqSectionType } from '../../../transports/common/faq-transport'
import { useTranslation } from '../../../hooks/locale'

interface FaqSectionProps {
    faqs?: FaqSectionType
}

const FaqSection: React.FC<FaqSectionProps> = ({ faqs }) => {
    const { t } = useTranslation()

    if (!faqs?.questionAnswers?.length) {
        return null
    }

    return (
        <Section>
            <Title>{t('pages.home.faq.heading')}</Title>
            <FaqList>
                {faqs.questionAnswers.map((faq, index) => (
                    <FaqItem key={index} faq={faq} />
                ))}
            </FaqList>
        </Section>
    )
}

export default FaqSection
